/* Formulario que antecede o WhatsApp, valendo em toda pagina da loja.
   Saiu de arcan-pdp.js, onde so funcionava na pagina de produto e na busca.
   Qualquer elemento com data-arcan-lead abre o formulario, incluindo o botao
   flutuante e os botoes de contato da pagina de produto.
   Eventos no dataLayer: IniciouFormulario, Lead, Contact. */
(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];

  function iniciar() {
    var dlg = document.getElementById('arcan-lead');
    if (!dlg || typeof dlg.showModal !== 'function') return;

    var form = document.getElementById('arcan-lead-form');
    var wrap = document.getElementById('arcan-lead-wrap');
    var done = document.getElementById('arcan-lead-done');
    var nome = document.getElementById('arcan-lead-nome');
    var mail = document.getElementById('arcan-lead-email');
    var fone = document.getElementById('arcan-lead-fone');
    var ir = document.getElementById('arcan-lead-go');
    var msg = document.getElementById('arcan-lead-msg');
    var fechar = document.getElementById('arcan-lead-close');
    if (!form || !wrap || !done || !nome || !mail || !fone || !ir || !fechar) return;

    var numero = (dlg.dataset.whatsapp || '').replace(/\D/g, '');
    var contexto = dlg.dataset.produto || '';
    var origem = 'flutuante';
    var devolver = null;

    function abrir(qual, botao) {
      origem = qual || 'flutuante';
      devolver = botao || null;
      wrap.hidden = false;
      done.hidden = true;
      form.reset();
      form.querySelectorAll('input').forEach(function (i) { i.removeAttribute('aria-invalid'); });
      dlg.showModal();
      dataLayer.push({ event: 'IniciouFormulario', origem: origem, produto: contexto });
      setTimeout(function () { nome.focus(); }, 60);
    }

    document.querySelectorAll('[data-arcan-lead]').forEach(function (bt) {
      bt.addEventListener('click', function () { abrir(bt.getAttribute('data-arcan-lead'), bt); });
    });

    function fecha() {
      dlg.close();
      if (devolver) { devolver.focus(); devolver = null; }
    }
    fechar.addEventListener('click', fecha);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) fecha(); });
    dlg.addEventListener('cancel', function () { if (devolver) { setTimeout(function () { devolver.focus(); }, 0); } });

    fone.addEventListener('input', function () {
      var d = fone.value.replace(/\D/g, '').slice(0, 11);
      if (d.length > 6) fone.value = '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length > 10 ? 7 : 6) + '-' + d.slice(d.length > 10 ? 7 : 6);
      else if (d.length > 2) fone.value = '(' + d.slice(0, 2) + ') ' + d.slice(2);
      else fone.value = d;
    });

    function valida(el, ok) {
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      return ok;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var okNome = valida(nome, nome.value.trim().length >= 2);
      var okMail = valida(mail, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail.value.trim()));
      var digitos = fone.value.replace(/\D/g, '');
      var okFone = valida(fone, digitos.length === 10 || digitos.length === 11);

      if (!okNome || !okMail || !okFone) {
        form.querySelector('[aria-invalid="true"]').focus();
        return;
      }

      /* aqui entra o envio pro n8n e o evento de Lead do Meta quando o tracking subir */
      dataLayer.push({
        event: 'Lead',
        origem: origem,
        produto: contexto,
        sku: dlg.dataset.sku || '',
        value: parseFloat(dlg.dataset.valor || '0'),
        currency: 'BRL',
        nome: nome.value.trim(),
        email: mail.value.trim(),
        telefone: digitos
      });

      if (numero) {
        var texto = origem === 'flutuante'
          ? 'Olá! Vim pelo site da Arcan TCG. Meu nome é ' + nome.value.trim() + '.'
          : 'Olá! Tenho interesse no ' + contexto + '. Meu nome é ' + nome.value.trim() + '.';
        ir.dataset.url = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(texto);
        ir.hidden = false;
      } else {
        ir.hidden = true;
        if (msg) msg.textContent = 'A gente te chama no WhatsApp em breve.';
      }

      wrap.hidden = true;
      done.hidden = false;
      ir.focus();
    });

    ir.addEventListener('click', function () {
      dataLayer.push({ event: 'Contact', origem: origem, produto: contexto });
      if (ir.dataset.url) window.open(ir.dataset.url, '_blank', 'noopener');
      dlg.close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
